import PageDefault from "components/PageDefault";
// import React from "react";
// import FlowController from "./FlowController";
// import GeneralController from "./GeneralController";
// import PermissionController from "./PermissionController";
// import StatusController from "./StatusController";
// import StepsController from "./StepsController";
import "./style.adm.scss";

export default function Admin(){
  return (
    <PageDefault title="Admin">
      <PageDefault.Title>Admin</PageDefault.Title>
      <PageDefault.ContentMenu>
        {/* <ContentMenuItem component={GeneralController} title="Geral"/>
        <ContentMenuItem component={PermissionController} title="Permissions"/>
        <ContentMenuItem component={StatusController} title="Status"/>
        <ContentMenuItem component={FlowController} title="Flow"/>
        <ContentMenuItem component={StepsController} title="Steps"/> */}
      </PageDefault.ContentMenu>
    </PageDefault>
  );
}